export const environment = {
  production: true,
  api_evs: 'https://api.zenify.biz',
  api_upload_evs: 'https://api.zenify.biz',
  url_socket: 'https://webrtc.zenify.biz?token=',
  url_email: 'https://api.zenify.biz/emailgateway',
  url_ottgateway: 'https://chat.zenify.biz/ottgateway',
  SERVER_CHAT: 'https://chat.zenify.biz/chatroom',
  url_embed: 'https://chat.zenify.biz',
  wav_cdn:
    '172.16.0.10-https://cdn.zenify.biz/s2|172.16.0.10-https://cdn.zenify.biz/s1|192.168.0.129-https://cdn.zenify.biz/s2|192.168.0.129-https://cdn.zenify.biz/s1',
  ipgeolocation_api_key: 'f152cf7fb9274299903a5c55be4e4cb3',
  cdn_server: 'https://cdn.zenify.biz',
  app_facebook_id: '144494440559884',
  app_zalo_id: '3127727296395854273',
  facebook_configuration_id: '311892598415542',
  dsn_sentry: 'https://0403fbf54553413690aa2e31b707b766@sentry.zenify.biz/3',
  code: {
    PHONE_ALERT_REQUEST_ID: 7000,
    CALL_ACTION_REQUEST_ID: 8888,
    CALL_ACTION_RESPONSE_ID: 8888,
    NEW_NOTIFICATION_ID: 100,
    NEW_EMAIL_RESPOND_ID: 5000,
    VOICE_ACTIVATED: 6666,
    LOGIN_REQUEST_ID: 2000,
    LOGOUT_REQUEST_ID: 2014,
    LOGIN_RESPOND_ID: 1000,
    LOGOUT_RESPOND_ID: 1003,
    // call flow
    IVRCALL_RESPOND_ID: 1125,
    NEW_CALL_RESPOND_ID: 1037,
    ROUTE_TO_QUEUE_RESPONSE_ID: 1126,
    RING_AGENT_RESPOND_ID: 1038,
    AGENT_ANSWER_RESPOND_ID: 1039,
    AGENT_END_CALL_RESPOND_ID: 1009,
    USER_END_CALL_RESPOND_ID: 1011,
    END_CALL_RESPOND_ID: 1012,
    // support
    SUPPORT_REQUEST_ID: 2003,
    SUPPORT_RESPOND_ID: 1032,
    CONFIRM_ANSWER_SUPPORT_REQUEST_ID: 2046,
    SUPPORT_AGENT_RESPOND_ID: 1074,
    CONFIRM_ANSWER_SUPPORT_RESPONSE_ID: 1075,
    // invite to conference
    INVITE_REQUEST_ID: 2007,
    INVITE_RESPOND_ID: 1005,
    INVITE_AGENT_TO_CONF_REQUEST_ID: 4031,
    INVITE_AGENT_TO_CONF_RESPOND_ID: 4033,
    REFUSE_INVITE_AGENT_TO_CONF_REQUEST_ID: 3097,
    REFUSE_INVITE_AGENT_TO_CONF_RESPOND_ID: 3099,

    // ngat
    TERMINATE_REQUEST_ID: 2009,
    TERMINATE_RESPOND_ID: 1006,
    // transfer
    TRANSFER_TO_AGENT_REQUEST_ID: 2109,
    REFUSE_TRANSFER_TO_AGENT_REQUEST_ID: 2110,
    TRANSFER_REQUEST_ID: 2010,
    TRANSFER_RESPOND_ID: 1007,

    TRANSFER_AGENT_TO_AGENT_REQUEST_ID: 2083,
    TRANSFER_AGENT_TO_AGENT_RESPOND_ID: 2084,

    TRANSFER_TO_AGENT_RESPOND_ID: 3091,
    REFUSE_TRANSFER_TO_AGENT_RESPOND_ID: 3092,

    // nghe len
    SPY_REQUEST_ID: 2011,
    SPY_RESPOND_ID: 1008,
    NOT_CONNECTED_SPY_RESPONSE_ID: 1053,
    // thay doi trang thai
    CHANGE_AGENT_STATUS_REQUEST: 2013,
    CHANGE_AGENT_STATUS_RESPOND_ID: 2013,
    // hold
    HOLD_REQUEST_ID: 2015,
    UN_HOLD_REQUEST_ID: 2016,
    HOLD_RESPOND_ID: 1029,
    UNHOLD_RESPOND_ID: 1028,

    // mute
    UNMUTE_REQUEST_ID: 2017,
    MUTE_REQUEST_ID: 2018,
    MUTE_RESPOND_ID: 1030,
    UNMUTE_RESPOND_ID: 1031,
    // agent chu dong end tren giao dien
    REMOVE_AGENT_REQUEST_ID: 2019,
    // transfer to ivr
    RECEIVE_IVR_LIST_REQUEST_ID: 2050,
    RECEIVE_IVR_LIST_REPONSE_ID: 1079,
    TRANSFER_TO_IVR_REQUEST_ID: 2040,
    TRANSFER_TO_IVR_RESPONSE_ID: 1062,

    // transfer to acd
    TRANSFER_TO_ACD_REQUEST_ID: 2052,
    RECEIVE_ACD_LIST_REQUEST_ID: 2054,
    RECEIVE_ACD_LIST_REPONSE_ID: 1082,
    TRANSFER_TO_ACD_REPONSE_ID: 1080,

    // coach call
    COACH_CALL_REQUEST_ID: 1077,
    COACH_CALL_RESPONSE_ID: 1078,
    UNCOACH_CALL_REQUEST_ID: 2105,
    UNCOACH_CALL_RESPONSE_ID: 1303,
    // agent reject
    AGENT_REJECT_CALL_REQUEST_ID: 6000,
    AGENT_REJECT_CALL_RESPONSE_ID: 6000,
    // cuop cuoc goi
    INTERCEPT_REQUEST_ID: 2108,
    TRANSFER_TO_PROFESSOR_REQUEST_ID: 2053,

    // outcall
    OUT_CALL_REQUEST_ID: 2032,
    OUT_CALL_RESPONSE_ID: 1055,
    OUTCALL_ERROR_RESPONSE_ID: 1083,
    TERMINATE_CALL_OUT_REQUEST_ID: 2033,

    // hanh dong gop chung
    PERFORMING_CALL_ACTION_REQUEST_ID: 2055,
    PERFORMING_CALL_ACTION_RESPONSE_ID: 4026,

    // lay 1 so danh sach
    SEARCH_AGENT_REQUEST_ID: 2047,
    SEARCH_AGENT_RESPONSE_ID: 1065,
    GET_AUX_REASON_REQUEST_ID: 2107,
    GET_AUX_REASON_RESPONSE_ID: 4022, // lay danh sach cac loai aux
    GET_LIST_SHIFT_REQUEST_ID: 1019,
    GET_LIST_SHIFT_RESPONSE_ID: 1019,
    UPDATE_AGENT_STATUS_RESPONSE_ID: 1021,

    DIVERT_INVITE_REQUEST: 1133,
    DIVERT_INVITE_RESPONSE: 1134,
    DIVERT_ANSWER_RESPONSE: 1135,
    DIVERT_STOP_RESPONSE: 1136,

    VM_CALLOUT_CUSTOMER: 3093, // goi lai khi nghe voicemail
    VOICEMAIL_INSERT_RECALL_TIME_REQUEST: 28000,
    VOICEMAIL_INSERT_RECALL_TIME_RESPONSE: 28001,
    VOICEMAIL_GET_LIST_REQUEST: 28004,
    CALLBACK_BOOK_REQUEST: 998111,
    VOICEMAIL_GET_LIST_RESPONSE: 28005,
    VOICEMAIL_GET_AGENT_REQUEST: 28006,
    VOICEMAIL_GET_AGENT_RESPONSE: 28007,
    VOICEMAIL_ASSIGN_MANUAL_REQUEST: 28008,
    VOICEMAIL_ASSIGN_MANUAL_RESPONSE: 28009,

    // lay thong tin thong ke
    GET_DETAIL_AGENT_IN_QUEUE_REQUEST: 9017,
    GET_DETAIL_AGENT_IN_QUEUE_RESPONSE: 9018,
    GET_DETAIL_QUEUE_REQUEST: 9015,
    GET_DETAIL_QUEUE_RESPONSE: 9016,
    GET_QUEUE_LIST_REQUEST_ID: 1057,
    GET_QUEUE_LIST_RESPONSE_ID: 1057,
    HISTORY_REQUEST_ID: 1300,
    HISTORY_RESPONSE_ID: 1301,
    // change agent call status
    CHANGE_AGENT_CALL_STATUS_RESPOND_ID: 1127,
    CHANGE_AGENT_CALL_STATUS_REQUEST_ID: 2093,
    // ping
    TEST_CONNECTION_REQUEST_ID: 2012,
    TEST_CONNECTION_RESPONSE_ID: 1036,
    // khi agent tu choi cuoc goi qua so lan
    RELOAD_AGENT_STATUS_RESPONSE_ID: 1020,
    // dang ky
    USER_PHONE_REGISTER: 8000,
    USER_PHONE_SELECT: 8003,

    SEND_CHAT_MESSAGE_EVENT: 10005,
    SUPVERVISOR_AGENT_RESPONSE_ID: 15001,
    SUPVERVISOR_CALL_RESPONSE_ID: 15000,
    CALL_DETAIL_RESPONSE_ID: 17000,
    CALL_LIST_RESPONSE_ID: 16000,
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts